module.exports = __webpack_public_path__ + "static/media/logo.739ac7f0.svg";